module.exports = __webpack_public_path__ + "static/media/order-analytics-img.9c747afa.svg";